import {
  Contact,
  CreateContactRequest,
  UpdateContactRequest,
  GetContactsParams,
} from '@/types/contact';
import { api } from './index';

class ContactService {
  /**
   * Get all contacts
   * GET /v3/contacts/
   */
  async getContacts(params?: GetContactsParams): Promise<Contact[]> {
    try {
      const response = await api.get<Contact[]>('/contacts/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching contacts:', error);
      throw error;
    }
  }

  /**
   * Create new contact
   * POST /v3/contacts/
   */
  async createContact(contactData: CreateContactRequest): Promise<Contact> {
    try {
      const response = await api.post<Contact>('/contacts/', contactData);
      return response.data;
    } catch (error) {
      console.error('Error creating contact:', error);
      throw error;
    }
  }

  /**
   * Get contact by ID
   * GET /v3/contacts/{contact_id}
   */
  async getContact(contactId: string): Promise<Contact> {
    try {
      const response = await api.get<Contact>(`/contacts/${contactId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching contact:', error);
      throw error;
    }
  }

  /**
   * Update contact
   * PATCH /v3/contacts/{contact_id}
   */
  async updateContact(contactId: string, contactData: UpdateContactRequest): Promise<Contact> {
    try {
      const response = await api.patch<Contact>(`/contacts/${contactId}`, contactData);
      return response.data;
    } catch (error) {
      console.error('Error updating contact:', error);
      throw error;
    }
  }

  /**
   * Delete contact
   * DELETE /v3/contacts/{contact_id}
   */
  async deleteContact(contactId: string): Promise<void> {
    try {
      await api.delete(`/contacts/${contactId}`);
    } catch (error) {
      console.error('Error deleting contact:', error);
      throw error;
    }
  }
}

export const contactService = new ContactService();
